import React, { useEffect } from "react";
import LocationModal from "../../templates/LeadTemplates/LeadModalsTemplate/LocationModal";
import SocialMediaModal from "../../templates/LeadTemplates/LeadModalsTemplate/SocialMediaModal";
import Loader from "../../atoms/Loader/Loader";
import ActionModal from "../../molecules/modal/ActionModal";
import ChatModal from "../../templates/LeadTemplates/LeadModalsTemplate/ChatModal";
import { SearchResult } from "../../../slices/leads/types";
import CompanyModal from "../../templates/LeadTemplates/LeadModalsTemplate/CompanyModal";
import { CompanyProfile } from "../../../pages/leads-management/models/ICompanyProfile";

interface LeadDetailsSubModalsProps {
  locationModal: boolean;
  setLocationModalShow: any;
  socialMediaModal: boolean;
  setSocialMediaModalShow: any;
  companyModal: boolean;
  setCompanyModalShow: (state: boolean) => void;
  chatModal: boolean;
  setChatModalShow: any;
  isLoading: boolean;
  userAddress: string;
  origin: any;
  destination: any;
  isConfirmationModalShow: boolean;
  handleCloseModal: () => void;
  handleConfirm: () => void;
  socialItems: SearchResult | null;
  companyProfile: CompanyProfile | null;
  isLoadingData: boolean;
  companyName: string;
}

const LeadDetailsSubModals: React.FC<LeadDetailsSubModalsProps> = ({
  locationModal,
  setLocationModalShow,
  socialMediaModal,
  setSocialMediaModalShow,
  isLoading,
  userAddress,
  origin,
  destination,
  isConfirmationModalShow,
  handleCloseModal,
  handleConfirm,
  socialItems,
  chatModal,
  setChatModalShow,
  companyModal,
  setCompanyModalShow,
  companyProfile,
  isLoadingData,
  companyName,
}) => {
  return (
    <>
      {locationModal ? (
        <LocationModal
          onHide={() => setLocationModalShow(false)}
          name="Location"
          show={locationModal}
          header={userAddress}
          bodyHeadline={""}
          bodyContent={""}
          origin={origin}
          destination={destination}
        />
      ) : null}
      {socialMediaModal ? (
        <SocialMediaModal
          onHide={() => setSocialMediaModalShow(false)}
          name="SocialMedia"
          show={socialMediaModal}
          header={"Social Media Details"}
          bodyHeadline={""}
          bodyContent={""}
          origin={origin}
          socialitems={socialItems}
        />
      ) : null}
      {companyModal ? (
        <CompanyModal
          onHide={() => setCompanyModalShow(false)}
          show={companyModal}
          companyProfile={companyProfile}
          isLoading={isLoadingData}
          companyName={companyName}
        />
      ) : null} 
      {chatModal ? (
        <ChatModal
          onHide={() => setChatModalShow(false)}
          name="Chat"
          header="Chat with Lead"
          show={chatModal}
          bodyHeadline={""}
          bodyContent={""}
        />
      ) : null}
      {isLoading ? <Loader /> : null}
      <ActionModal
        title={"Delete Item"}
        show={isConfirmationModalShow}
        onClose={handleCloseModal}
        onConfirm={handleConfirm}
      >
        <p className="modal-content">
          Are you sure you want to delete this item?
        </p>
      </ActionModal>
    </>
  );
};

export default LeadDetailsSubModals;
